// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "selector-34Em9";
export { _1 as "__esModule", _2 as "selector" }
export default { "__esModule": _1, "selector": _2 }
